import type { UserStateItemKey } from "../../types/user-state";
import {
  isAppliedJobKey,
  isBrowsedJobKey,
  isSavedJobKey,
  isViewedJobKey,
} from "../../types/user-state";

/**
 * Path segment for {@link userStateApi} requests. Job-related keys use `/job/{bucket}/{jobId}`
 * so the URL never contains a raw `#` (which would be treated as a fragment and dropped
 * before the request reaches the server).
 */
export function buildUserStateItemApiPath(itemKey: UserStateItemKey): string {
  if (isSavedJobKey(itemKey)) {
    return `/job/saved/${encodeURIComponent(itemKey.slice("savedJob#".length))}`;
  }
  if (isViewedJobKey(itemKey)) {
    return `/job/viewed/${encodeURIComponent(itemKey.slice("viewedJob#".length))}`;
  }
  if (isAppliedJobKey(itemKey)) {
    return `/job/applied/${encodeURIComponent(itemKey.slice("appliedJob#".length))}`;
  }
  if (isBrowsedJobKey(itemKey)) {
    return `/job/browsed/${encodeURIComponent(itemKey.slice("browsedJob#".length))}`;
  }
  return `/${encodeURIComponent(itemKey)}`;
}
